<template>
  <select-form
    ref="selectForm"
    title="Liabilities"
    :select="{
      label: 'Liability Type',
      addLabel: '+ New',
      prefix: 'financial-liabilities-',
      attr: 'type',
      model: select,
      map: map.snake,
    }"
    :items="items"
    :items-map="map.camel"
    @hide-modal="resetModels"
    @item-clicked="item => $emit('item-clicked', item, 'liabilities')"
  >
    <vue-form-generator
      :schema="form.schema"
      :options="form.options"
      :model="model"
      ref="liabilityForm"
    >
    </vue-form-generator>
    <address-form-fields
      v-if="select.type === 'banks'"
      ref="addressForm"
      :form="address"
      @address-updated="address = $event"
    />
    <b-row>
      <b-col class="col-auto ml-auto">
          <add-asset-button
            id="extra-asset"
            style-class-row="pr-3"
            button-text="Add Liability"
            @submit="submitLiability"
          />
      </b-col>
    </b-row>
  </select-form>
</template>

<script>
import formHelper from '@/libs/forms';
import { UPDATE_LIABILITIES } from '@/vuex/modules/profile/types/actions';

import AddAssetButton from '@/components/utils/buttons/misc/AddAssetButton';
import AddressFormFields from '@/components/utils/address/AddressFormFields';
import SelectForm from '@/components/profile/sections/tabs/financial/SelectForm';
import LIABILITY_SCHEMAS from '@/components/profile/sections/tabs/financial/liabilities/schemas';
import LIABILITY_TYPE_MAP from '@/components/profile/sections/tabs/financial/resources/liabilityTypeMap';


export default {
  components: {
    AddAssetButton,
    SelectForm,
    AddressFormFields,
  },
  data() {
    return {
      select: {},
      model: {},
      address: {},
      map: LIABILITY_TYPE_MAP,
    };
  },
  computed: {
    form() {
      const type = this.select.type;
      if (!type) { return { schema: { fields: [] }, options: {} }; }

      return {
        schema: LIABILITY_SCHEMAS[type],
        options: formHelper.options(`financial-liability-${type}`, true),
      };
    },
    items() {
      return this.$store.getters.profile.finances.liabilities || {};
    },
  },
  methods: {
    resetModels() {
      this.select = {};
      this.model = {};
    },
    submitLiability(extraItem) {
      const type = this.select.type;
      const isBanks = type === 'banks';
      if (
        !this.$refs.liabilityForm.validate() ||
        (isBanks && !this.$refs.addressForm.validate())
      ) { return; }

      const data = this.model;
      if (isBanks) {
        data.address = this.address;
      }
      const url = `/users/${this.$store.getters.user.id}/profile/finances/liabilities/${type}`;
      this.$reqs.post(url, data)
        .then((result) => {
          this.$store.dispatch(UPDATE_LIABILITIES, result.data);
          this.$notify({ group: 'alert', text: 'New Liability Added.' });
          if (extraItem) {
            this.model = {};
            this.$refs.selectForm.showModal();
          } else {
            this.$refs.selectForm.hideModal();
          }
        })
        .catch(() => {});
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/financial/liabilities/LiabilitiesContainer.vue